import type { GraphQLError } from 'graphql';

import { isAuthorizationError } from 'src/shared/graphql';
import { logInfo } from 'src/shared/telemetry/logger';

/* eslint-disable @typescript-eslint/no-unsafe-argument */
export const handleAuthenticationException = (
  e: GraphQLError | Error | any,
) => {
  if (isAuthorizationError(e)) {
    logInfo('Encountered authorization error, this is expected behaviour.');
  }
  throw e;
};
/* eslint-enable */
